export default __webpack_public_path__ + "faa443b8638f74b22cda7aee182112c9.jpg";